import { Container, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { init, search } from "../../redux/actions/evaluationAnalysis";
import Header from "../common/Header";
import { PRINTING_RESET, dataAnalysisPrint } from "../../redux/actions/printing";

export default function EvaluationAnalysis() {
  const downloadLink = useSelector(state => state.printing.downloadLink);
  const { register, handleSubmit, getValues, formState: { errors } } = useForm();
  const columns = [
    {
      field: "serialNumber",
      headerName: "通し番号",
      width: 190,
      editable: false,
      headerClassName: "headerColor",
      flex: 0.5
    },
    { field: "grade", headerName: "年", width: 100, editable: false, headerClassName: "headerColor", flex: 0.5 },
    { field: "class", headerName: "組", width: 100, editable: false, headerClassName: "headerColor", flex: 0.5 },
    { field: "number", headerName: "番", width: 100, editable: false, headerClassName: "headerColor", flex: 0.5 },
    { field: "name", headerName: "生徒氏名", width: 335, editable: false, headerClassName: "headerColor", flex: 1 }
  ];

  const [gridData, setGridData] = useState([]);

  const dispatch = useDispatch();
  const rows = useSelector(state => state.evaluationAnalysis.rows);
  const evaluationList = useSelector(state => state.evaluationAnalysis.evaluationList);

  useEffect(
    () => {
      dispatch(init());
    },
    [dispatch]
  );

  useEffect(
    () => {
      setGridData(rows);
    },
    [rows]
  );

  useEffect(
    () => {
      if (downloadLink) {
        window.open(`/neqst${downloadLink}`, "_blank");
        dispatch({ type: PRINTING_RESET });
      }
    },
    [downloadLink]
  );

  const searchSubmit = request => {
    dispatch(
      search({
        ...request,
        listId: request.listId ? request.listId : ""
      })
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const handleSelectionModelChange = selectionModel => {
    setSelectedRows(selectionModel);
  };
  const submitDataAnalysisPage = () => {
    const selectedData = selectedRows.map(rowId => gridData.find(row => row.id === rowId));
    if (selectedData.length !== 1) {
      alert("生徒を1人だけ選択してください。");
      return;
    }
    const params = `?studentId=${selectedData[0].serialNumber}&listId=${getValues().listId}`;

    window.location.href = `/DataAnalysis${params}`;
  };

  const handlePrintButton = () => {
    const selectedData = selectedRows.map(rowId => gridData.find(row => row.id === rowId));
    const request = {
      printTarget: 5,
      listId: getValues("listId"),
      students: selectedData.map(data => {
        return {
          serialNumber: data.serialNumber,
          grade: data.grade
        };
      })
    };
    dispatch(dataAnalysisPrint(request));
  };

  return (
    <Box>
      <Header />
      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: 4,
            marginLeft: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価分析
          </Typography>
        </Box>

        <Box
          sx={{
            m: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              margin: 2,
              align: "left",
              justifyContent: "left"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              いずれか入力された内容で検索します。
            </Typography>
          </Box>
          {errors.listId &&
            <span>
              {errors.listId.message}
            </span>}
          <Box
            sx={{
              m: 2,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Grid container sx={{flexGrow: 1}} spacing={1} alignItems={"flex-start"} justifyContent={"flex-start"} textAlign={"left"}>

              <Grid item xs={4} lg={3} mt={1} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    通し番号
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9} mt={1} >
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("serialNumber", {
                      pattern: { value: /^[0-9]+$/, message: "通し番号は数字で入力してください。" }
                    })}
                  />
                  {errors.serialNumber &&
                    <span className="error-msg">
                      {errors.serialNumber.message} <br />
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    学年
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("grade", {
                      pattern: { value: /^[0-9]+$/, message: "学年は数字で入力してください。" }
                    })}
                  />
                  {errors.grade &&
                    <span className="error-msg">
                      {errors.grade.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    クラス
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("class", {
                      pattern: { value: /^[0-9]+$/, message: "クラスは数字で入力してください。" }
                    })}
                  />
                  {errors.class &&
                    <span className="error-msg">
                      {errors.class.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    番号
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("number", {
                      pattern: { value: /^[0-9]+$/, message: "番号は数字で入力してください。" }
                    })}
                  />
                  {errors.number &&
                    <span className="error-msg">
                      {errors.number.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    氏名
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("name")}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              margin: 2,
              ml: 10,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              評価内容
            </Typography>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#FFFFFF",
              border: "1.5px solid black"
            }}
          >
            <FormControl
              sx={{
                ml: 1
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {evaluationList.map(list =>
                  <FormControlLabel
                    key={list.listId}
                    value={list.listId}
                    control={<Radio />}
                    label={list.listName}
                    {...register("listId")}
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box
            sx={{
              ml: 5,
              mr: 10
            }}
          >
            <FormControl
              sx={{
                m: 2
              }}
            />
          </Box>
        </Box>

        <Container maxWidth="sm">
          <Stack sx={{ mr: 7 }} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={handleSubmit(searchSubmit)}>
              検索
            </Button>
          </Stack>
        </Container>

        <Box
          sx={{
            m: 2,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box
            sx={{
              mr: 5,
              mt: 2,
              mb: 2,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h3" variant="h7" align="left">
              検索結果
            </Typography>
          </Box>

          <Box sx={{ alignItems: "center", justifyContent: "center" }} fullWidth>
            <div
              style={{
                height: 330,
                width: "100%",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <DataGrid
                sx={{
                  bgcolor: "white",
                  " .headerColor": {
                    backgroundColor: "#ffcc80"
                  }
                }}
                rows={gridData}
                columns={columns}
                onSelectionModelChange={handleSelectionModelChange}
                checkboxSelection
                localeText={{
                  noRowsLabel: "ロールはありません"
                }}
              />
            </div>
          </Box>

          <Container maxWidth="sm">
            <Stack sx={{ pt: 4 }} direction="row" spacing={5} justifyContent="center">
              <Button onClick={handlePrintButton} variant="contained" fullWidth sx={{ bgcolor: "#82b1ff" }}>
                一括PDF化
              </Button>
              <Button variant="contained" fullWidth onClick={submitDataAnalysisPage} sx={{ bgcolor: "#82b1ff" }}>
                確認
              </Button>
            </Stack>
          </Container>
        </Box>

        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="StaffMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
